import React, { useCallback } from "react"
import AppCommonFiltersMarkets from "@components/NewCommonFilters/@components/Autocomplete/Markets"
import { BACKEND_APIS } from "@constants"
import { autoEuropePricingIdDrawerData } from "Pages/AutoEuropeTool/PricingId/@signals"

export default function AutoEuropePricingIdMarketField() {
	const value = autoEuropePricingIdDrawerData.value.market ?? null

	const onChange = useCallback((e) => {
		autoEuropePricingIdDrawerData.value = { ...autoEuropePricingIdDrawerData.value, market: e.target.value }
	}, [])

	return <AppCommonFiltersMarkets
		label="Site Market"
		placeholder="All markets"
		urlAjax={`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/markets`}
		value={value?.value ?? value}
		onChange={onChange}
	/>
}